import { combineReducers } from "@reduxjs/toolkit";
import dashboardReducer from "../modules/dashboard/store/";
import userReducer from "../modules/users/store/reducer";
import subscriptionReducer from "../modules/subscription/store/reducer";
import authReducer from "../modules/authentication/store/reducer";
import layoutReducer from "../layout/store/reducer";
import memoirReducer from "../modules/memoirs/store/reducer";
import biographyReducer from "../modules/biographies/store/reducer";
const reducer = combineReducers({
  dashboard: dashboardReducer,
  auth: authReducer,
  layout: layoutReducer,
  users: userReducer,
  subscription: subscriptionReducer,
  memoirs: memoirReducer,
  biographies: biographyReducer,
});
export default reducer;
